import * as React from 'react'
function SvgChevronDown(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.172 26.905L7.467 17.2a2.64 2.64 0 113.733-3.733l8.8 8.8 8.8-8.8a2.64 2.64 0 113.733 3.733l-9.705 9.705a4 4 0 01-5.656 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronDown
